/* eslint-disable */
import React, { useEffect, useState, useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { getClientSecret } from './api';
import { Box } from '@material-ui/core';
import {
  DefaultPurchaseInformation,
  Loading,
  ErrorMessage,
  CheckoutForm,
  DefaultCustomerInformationForm,
  SuccessMessage
} from './Components';
import styles from './Components/main.module.css';
import { PAYMENT_METHODS, STRIPE_KEY } from './defaults';

const paymentIntent = new URL(document.location).searchParams.get(
  'payment_intent'
);

const redirectStatus = new URL(document.location).searchParams.get(
  'redirect_status'
);

const errorTranslations = {
  de: {
    missing_stripe_credentials:
      'Auf der Seite des Restaurants ist ein Fehler aufgetreten',
    payable_item_not_found:
      'Beim erstellen Ihrer Bestellung ist ein Fehler aufgetreten.',
    payable_item_paid: 'Ihre Bestellung wurde bereits bezahlt'
  },
  en: {
    missing_stripe_credentials:
      'An error occured on the site of the restaurant',
    payable_item_not_found: 'An error occured when creating your order',
    payable_item_paid: 'Your order has allready been paid.'
  }
};

const stringifyErrorMessage = (err, lang = 'de') => {
  let translation = errorTranslations[lang][err];

  if (translation) return translation;

  return err;
};

const GastronautPayment = ({
  restaurantId = null,
  payableItemId = null,
  paymentMethods = PAYMENT_METHODS,
  containerProps = {},
  PurchaseInformation = DefaultPurchaseInformation,
  hidePurchaseInfo = false,
  CustomerInformationForm = DefaultCustomerInformationForm,
  hideCustomerInfo = false,
  language = 'de',
  customer: defaultCustomer = {},
  onPaymentSuccess = () => {},
  onPaymentError = () => {},
  returnUrl: return_url = null,
  requiredFields = ['last_name', 'email']
}) => {
  const [stripeAccount, setstripeAccount] = useState(null);
  const [success, setsuccess] = useState();
  const [error, seterror] = useState(null);
  const [loading, setloading] = useState(true);
  const [payableItem, setpayableItem] = useState({});
  const [clientSecret, setclientSecret] = useState(null);
  const [customer, setcustomer] = useState(defaultCustomer);

  useEffect(() => {
    setloading(true);

    getClientSecret({
      restaurantId,
      payableItemId,
      paymentMethods,
      paymentIntent,
      redirectStatus
    })
      .then(({ data }) => {
        if (data.error === 'payable_item_paid') {
          setsuccess({ message: 'payable_item_paid', ...data.paymentIntent });
          onPaymentSuccess(data.paymentIntent);
        } else {
          setclientSecret(data.clientSecret);
          setstripeAccount(data.stripeAccount);
          setpayableItem(data.payableItem);
        }
      })
      .catch(({ message, response }) => {
        if (!response) {
          seterror(stringifyErrorMessage(message, language));
        } else {
          seterror(stringifyErrorMessage(response.data.message, language));
        }
      })
      .finally(() => setloading(false));
  }, [restaurantId, payableItemId]);

  const stripePromise = useMemo(
    () => loadStripe(STRIPE_KEY, { stripeAccount }),
    [stripeAccount]
  );

  if (success) {
    return <SuccessMessage paymentIntent={success} language={language} />;
  }

  return (
    <Box {...containerProps} className={styles.container}>
      {loading && <Loading />}
      {error && <ErrorMessage error={error} />}
      {!loading && stripeAccount && !error && (
        <Box className={styles.formContainer}>
          {!hideCustomerInfo && (
            <CustomerInformationForm {...{ customer, setcustomer, language }} />
          )}
          <Elements stripe={stripePromise}>
            <CheckoutForm
              clientSecret={clientSecret}
              amount={payableItem.amount}
              payableItemId={payableItemId}
              restaurantId={restaurantId}
              currency={payableItem.currency}
              customer={customer}
              paymentMethods={paymentMethods}
              language={language}
              requiredFields={requiredFields}
              onPaymentSuccess={({ paymentIntent = {} }) => {
                setsuccess(paymentIntent);
                onPaymentSuccess(paymentIntent);
              }}
              onPaymentError={error => {
                seterror(error.message);
                onPaymentError(error);
              }}
              return_url={return_url}
            />
          </Elements>
        </Box>
      )}
      {!loading && !hidePurchaseInfo && payableItem && !error && (
        <PurchaseInformation {...payableItem} language={language} />
      )}
    </Box>
  );
};

export default GastronautPayment;
